import * as FluxUtils from 'flux/utils';

import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';

export interface FloorPlanStoreState {
    angle: number;
    file: File | null;
    image_id: string;
    orientation: number;
    ratio: number;
}

class FloorPlanStoreClass extends FluxUtils.ReduceStore<FloorPlanStoreState, unknown> {
    get image(): HTMLImageElement {return document.getElementById('fp-image') as HTMLImageElement; }

    public getInitialState(): FloorPlanStoreState {
        return {
            angle: 0,
            file: null,
            image_id: '',
            orientation: 0,
            ratio: 1
        };
    }

    public reduce(state: FloorPlanStoreState, action: DispatcherBaseAction): FloorPlanStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.RESET_PROJECT_RELATED_SETTINGS:
                return jQuery.extend({}, this.getInitialState());
            case ActionConstants.SET_FLOORPLAN_ORIENTATION:
                return jQuery.extend({}, state, {orientation: action.value});
            case ActionConstants.SET_FLOORPLAN_RATIO:
                return jQuery.extend({}, state, {ratio: action.value});
            case ActionConstants.SET_FLOORPLAN_ANGLE:
                return jQuery.extend({}, state, {angle: action.value});
            case ActionConstants.SET_IMAGE_ID:
                return jQuery.extend({}, state, {image_id: action.value});
            case ActionConstants.SETUP_FLOORPLAN:
                return jQuery.extend({}, state, action.value);
            case ActionConstants.SET_FLOORPLAN_IMAGE:
                return jQuery.extend({}, state, {file: action.value});
            default:
                break;
        }
        return state;
    }
}

export let FloorPlanStore: FloorPlanStoreClass = new FloorPlanStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/FloorPlanStore.ts